import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { SchemasFactory, ContentFactory, Content } from '../../squidex';
import { Observable, of } from 'rxjs';
import { AppTokenService } from '../../../app-token.service';
import { MenuItemModel } from './menu-item.model';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MenuItemService extends BaseService {

    constructor(schemasFactory: SchemasFactory,
        contentFactory: ContentFactory) {
        super(AppTokenService.MENU_ITEM_SCHEMA_NAME, contentFactory);
    }

}
